export default __webpack_public_path__ + "static/media/lockdown-business-continuity.5a56d614.png";